module.exports = __webpack_public_path__ + "media/beaver_creek.eb629b64.mp3";